import { render } from "./pageheader.vue?vue&type=template&id=966a3104"
import script from "./pageheader.vue?vue&type=script&lang=js"
export * from "./pageheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__